import { createPortal } from 'react-dom';

// MUI Components
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { useEffect, useState } from 'react';
import PopAddEditHotspot from '../../components/Space/PopAddEditHotspot';
import PopAddEditHistory from '../../components/Space/PopAddEditHistory';
import PopLockNorth from '../../components/Space/PopLockNorth';
import PopLanguages from '../../components/PopLanguages';
import PopNarations from '../../components/PopNarations';

import { ASSETS_PATH } from '../../constants';
import { useParams } from 'react-router-dom';
import CircularWithValueLabel from '../../components/CircularWithValueLabel';
import Swal from 'sweetalert2';
import axiosClient from '../../services/axios-client';

import { HiMiniLanguage } from "react-icons/hi2";



const Space = () => {

    const [editHotspot, setEditHotspot] = useState(null)
    const [editHistory, setEditHistory] = useState(null);
    const [editNorth, setEditNorth] = useState(false); // to open lock north popup
    const { space_id } = useParams();
    const [/** */, setSpaceId] = useState();
    const [spaces, setSpaces] = useState([]);
    const [spaceName, setSpaceName] = useState("");
    const [spaceNameLs, setSpaceNameLs] = useState({})
    const [spaceIdentifier, setSpaceIdentifier] = useState("");
    const [spaceBeaconId, setSpaceBeaconId] = useState("");
    const [spaceImage, setSpaceImage] = useState("");
    const [spaceVideo, setSpaceVideo] = useState("");
    const [hotspots, setHotspots] = useState([]);
    const [history, setHistory] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);

    const [langPop, setLangPop] = useState(false);
    const [northDirection, setNorthDirection] = useState(0);

    const [narrations, setNarrations] = useState(null);
    const [narrationsExtended, setNarrationsExtended] = useState(null);
    const [narrationsPop, setNarrationsPop] = useState(false);
    const [narrationsExtendedPop, setNarrationsExtendedPop] = useState(false);



    const onChangeUploadSpaceImage = (e) => {
        uploadAsset(e, (fileName) => { setSpaceImage(fileName) });
    }

    const onChangeUploadSpaceVideo = (e) => {
        uploadAsset(e, (fileName) => {
            setSpaceVideo("");
            setTimeout(() => { setSpaceVideo(fileName) }, 1000);
        });


    }


    useEffect(() => {
        if (space_id) {
            fetch(`${process.env.REACT_APP_API_URL}/space`, { method: 'GET' })
                .then((res) => res.json())
                .then((json) => {
                    setSpaces(json.spaces);
                    setPageData(json.spaces.find(space => space.space_id === parseInt(space_id)));
                });
        }
    }, [space_id])



    const setPageData = (space) => {

        setSpaceId(space.space_id);
        setSpaceName(space.space_name);
        setSpaceNameLs(space.space_name_ls || {})
        setSpaceIdentifier(space.space_identifier);
        setSpaceBeaconId(space.space_beacon_id);
        setSpaceImage(space.space_image);
        setSpaceVideo(space.space_video);
        setNorthDirection(space.space_north_direction);
        // console.log(JSON.parse(space.space_hotspots));

        if (space.space_audio) {
            setNarrations(space.space_audio);
        }else{
            setNarrations({});
        }

        if (space.space_audio_extended) {
            setNarrationsExtended(space.space_audio_extended);
        }else{
            setNarrationsExtended({});
        }

        if (space.space_hotspots) {

            setHotspots(space.space_hotspots);
        }

        if (space.space_history) {

            setHistory(space.space_history);
        }

    }


    useEffect(() => {
        //console.log(spaceImage);
    }, [spaceImage]);


    const nextHotspotId = () => {

        if (hotspots.length === 0) return 1;

        const ids = [];

        hotspots.forEach(ht => {
            ids.push(ht.hotspot_id);
        });

        //console.log("ids", ids);
        return Math.max(...ids) + 1;
    }


    const nextEraId = () => {

        if (history.length === 0) return 1;

        const ids = [];

        history.forEach(ht => {
            ids.push(ht.hotspot_id);
        });

        //console.log("ids", ids);
        return Math.max(...ids) + 1;
    }

    /* const uploadAsset = async (e, cb) => {
        let filename = "file.jpg";

        let formData = new FormData();
        formData.append("file", e.target.files[0]);

        try {
            const result = await fetch(`${process.env.REACT_APP_API_URL}/upload-file`, {
                method: "POST",
                body: formData,

            })

            const filename = await result.json();

            cb(filename.filename);

        } catch (err) {
            console.log(err);

        }

    } */


    const uploadAsset = async (e, cb) => {

        setUploading(true);

        let formData = new FormData();
        formData.append("file", e.target.files[0]);

        axiosClient.post(`${process.env.REACT_APP_API_URL}/upload-file`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress: event => {
                console.log(event.loaded)
                setProgress(100 * event.loaded / event.total);
            }
        }).then((res) => {
            //console.log(res);
            cb(res.data.filename);
            setUploading(false);
        })

    }


    const onChangeSpaceName = (e) => {
        const s = e.target.value;
        setSpaceName(s);
    }

    const onChangeSpaceIdentifier = (e) => {
        const s = e.target.value;
        setSpaceIdentifier(s);
    }


    const onChangeSpaceBeaconId = (e) => {
        const s = e.target.value;
        setSpaceBeaconId(s);
    }

    const onEditHotspot = (hotspot) => {

        setEditHotspot({ ...hotspot });

    }

    const onDeleteHotspot = (index) => {
        const h = [...hotspots];
        h.splice(index, 1);
        setHotspots(h);
    }

    const updateHotspot = (hotspot) => {
        //console.log(hotspot);
        let hsps = [...hotspots];
        let index = hotspots.findIndex((h) => h.hotspot_id === hotspot.hotspot_id);

        if (index < 0) {
            hsps.push(hotspot);
        } else {
            hsps[index] = hotspot;
        }


        setHotspots(hsps);
        setEditHotspot(null);
        //console.log(hotspots);
    }


    const onDone = () => {
        setEditHotspot(null);
    }

    const onAddHotspot = () => {
        const h = {
            hotspot_id: nextHotspotId(),
            hotspot_name: "",
            hotspot_type: "none",
            hotspot_data: {
                hotspot_linked_to: 0,
                title: "",
                description: "",
                narration_url: "",
                gallery: [],
                artefact: {
                    model_url: "",
                    model_map_url: ""
                }
            }
        };
        console.log(h);
        setEditHotspot(h)
    }


    const onEditHistory = (era) => {
        setEditHistory(era);
    }

    const onDeleteHistory = (index) => {
        const h = [...history];
        h.splice(index, 1);
        setHistory(h);
    }

    const onHistoryDone = () => {
        setEditHistory(null);
    }

    const onUpdateHistory = (era) => {

        let eras = [...history];
        let index = eras.findIndex((e) => e.era_id === era.era_id);

        if (index < 0) {
            eras.push(era);
        } else {
            eras[index] = era;
        }


        setHistory(eras);
        setEditHistory(null);

    }


    const onOpenNorthPopup = () => {
        setEditNorth(true);
    }

    const onCloseNorthPopup = () => {
        setEditNorth(false);
    }


    const onClickAddNewEra = (e) => {
        setEditHistory({ era_id: nextEraId(), asset_url: "", year: "" });
    }


    const onSaveSpace = async () => {
        try {
            const payload = {
                space_id: space_id,
                space_name: spaceName,
                space_name_ls: JSON.stringify(spaceNameLs),
                space_identifier: spaceIdentifier,
                space_beacon_id: spaceBeaconId,
                space_north_direction: northDirection,
                space_image: spaceImage,
                space_video: spaceVideo,
                space_audio: JSON.stringify(narrations),
                space_audio_extended: JSON.stringify(narrationsExtended),
                space_hotspots: JSON.stringify(hotspots),
                space_history: JSON.stringify(history)
            }
    
            const response = await fetch(`${process.env.REACT_APP_API_URL}/space`, {
                method: "PUT",
                body: JSON.stringify(payload),
                headers: {
                    "Content-Type": "application/json",
                }
            });
    
            const json = await response.json();
    
            if (!response.ok) {
                throw new Error(json.message || 'Failed to save space');
            }
    
            Swal.fire('Saved!', json.message || 'Space has been saved successfully.', 'success');
        } catch (err) {
            console.error(err);
            Swal.fire('Error!', err instanceof Error ? err.message : 'An unknown error occurred.', 'error');
        }
    }

    const onRemoveSpaceImage = () => {
        setSpaceImage("");
    }


    const onRemoveSpaceVideo = () => {
        setSpaceVideo("");
    }

    const onSpaceNameLangPop = () => {
        setLangPop(true);
    }

    const onSpaceNameLangPopClose = () => {
        setLangPop(false);
    }

    const onSetSpaceNameLs = (langs) => {
        setSpaceNameLs(prevLs => { return { ...langs } })
        setLangPop(false);
    }


const onSetNarrations = (narrations) => {        
        setNarrations(narrations);
        setNarrationsPop(false);
    }

    const onNarrationsPopClose = () => {
        setNarrationsPop(false);
    }


    const onNarrPopup = () => {
        setNarrationsPop(true);
    }

    const onSetNarrationsExtended = (narrations) => {        
        setNarrationsExtended(narrations);
        setNarrationsExtendedPop(false);
    }

    const onNarrationsExtendedPopClose = () => {
        setNarrationsExtendedPop(false);
    }


    const onNarrExtendedPopup = () => {
        setNarrationsExtendedPop(true);
    }

    return (
        <>
            <div className="content-header pb-6">
                Space Name
            </div>
            <div className="content-body">
                <form className='flex flex-col items-start gap-8'>
                    <div className='flex flex-row'>
                        <TextField
                            className='textfield w-full'
                            id="space-name"
                            label="Space Name"
                            value={spaceName}
                            onChange={onChangeSpaceName}
                        />
                        <IconButton aria-label="Add space name in other languages" onClick={onSpaceNameLangPop}>

                            <HiMiniLanguage className='l-icon' />
                        </IconButton>
                    </div>




                    <TextField
                        label="Space Identifier"
                        className='textfield w-full'
                        id="space-identifier"
                        value={spaceIdentifier}
                        onChange={onChangeSpaceIdentifier}
                        helperText={'If you changing identifier, Make sure QR code image need to be updated as well if already created.'}
                    />


                    <TextField
                        label="Beacon ID"
                        className='textfield w-full'
                        id="space-beacon-id"
                        value={spaceBeaconId}
                        onChange={onChangeSpaceBeaconId}
                        helperText={'You can find the beacon ID on the back side of the Beacon device.'}
                    />


                    <img src={`${ASSETS_PATH}/${spaceImage}`} width={400} alt="Space" />

                    {!spaceImage && <Button
                        variant="contained"
                        component="label"
                        style={{ marginRight: "10px" }}
                    >
                        *Upload Image
                        <input
                            type="file"
                            hidden
                            onChange={onChangeUploadSpaceImage}
                        />
                    </Button>}
                    {spaceImage && <div className='flex flex-row gap-4'><Button variant="contained" onClick={onOpenNorthPopup}>Lock North</Button><Button onClick={onRemoveSpaceImage}>Remove Image</Button></div>}

                    {false && spaceVideo && <video width={400} controls autoPlay id="spaceVideo">
                        <source src={`${ASSETS_PATH}/${spaceVideo}`} mime_type="video/mp4" />
                    </video>}
                    {false && !spaceVideo && <Button
                        variant="contained"
                        component="label"
                    >
                        Upload Video
                        <input
                            type="file"
                            hidden
                            onChange={onChangeUploadSpaceVideo}
                        />
                    </Button>}
                    {false && spaceVideo && <Button onClick={onRemoveSpaceVideo}>Remove Video</Button>}

                    <Button variant='contained' onClick={onNarrPopup}>Audio About Space</Button>
                    <Button variant='contained' onClick={onNarrExtendedPopup}>Extended Audio About Space</Button>

                    <h2>Add Hotspots </h2>

                    <Button variant="contained" onClick={onAddHotspot}>Add Hotspot</Button>

                    <table className="table-auto border w-full">
                        <thead>
                            <tr>
                                <th className="font-bold p-2 border-b text-left w-2">No</th>
                                <th className="font-bold p-2 border-b text-left">Hotspot Name</th>
                                <th className="font-bold p-2 border-b text-left">Hotspot Type</th>
                                <th className="font-bold py-2 px-4 border-b text-left">Actions</th>
                            </tr>
                        </thead>
                        <tbody>

                            {hotspots.map((hotspot, index) => <tr key={index}>
                                <td className="p-2 border-b text-left">{index + 1}</td>
                                <td className="p-2 border-b text-left">{hotspot.hotspot_name}</td>
                                <td className="p-2 border-b text-left">{hotspot.hotspot_type[0].toUpperCase() + hotspot.hotspot_type.slice(1)}</td>
                                <td className="py-2 px-4 border-b text-left">
                                    <Button onClick={() => { onEditHotspot(hotspot) }}>Edit</Button>
                                    <Button onClick={() => { onDeleteHotspot(index) }}>Delete</Button>
                                </td>
                            </tr>)}

                        </tbody>
                    </table>
                    <h2>Hitory</h2>
                    <Button onClick={onClickAddNewEra}>Add New Year</Button>

                    <table className="table-auto border w-full">
                        <thead>
                            <tr>
                                <th className="font-bold p-2 border-b text-left w-2">Year</th>
                                <th className="font-bold p-2 border-b text-left">Preview</th>
                                <th className="font-bold py-2 px-4 border-b text-left">Actions</th>
                            </tr>
                        </thead>
                        <tbody>

                            {history.map((era, index) => <tr key={era.year}>
                                <td className="p-2 border-b text-left">{era.year}</td>
                                <td className="p-2 border-b text-left"><img src={`${ASSETS_PATH}/${era.asset_url}`} width={150} alt={`${era.year}`} /></td>
                                <td className="py-2 px-4 border-b text-left">
                                    <Button onClick={() => { onEditHistory(era) }}>Edit</Button>
                                    <Button onClick={() => { onDeleteHistory(index) }}>Delete</Button>
                                </td>
                            </tr>)}

                        </tbody>
                    </table>
                    <Button onClick={onSaveSpace}>Save</Button>
                    <Button>Cancel</Button>
                </form>

                {
                    editHotspot &&
                    <PopAddEditHotspot
                        updateHotspot={updateHotspot}
                        hotspot={editHotspot}
                        onDone={onDone}
                        spaces={spaces}
                        spaceImage={spaceImage}
                        uploadAsset={uploadAsset}
                    />}

                {
                    editHistory &&
                    <PopAddEditHistory
                        era={editHistory}
                        onHistoryDone={onHistoryDone}
                        onUpdateHistory={onUpdateHistory}
                        uploadAsset={uploadAsset}
                    />
                }
                {
                    editNorth &&
                    <PopLockNorth
                        onClose={onCloseNorthPopup}
                        northDirection={northDirection}
                        setNorthDirection={setNorthDirection}
                        spaceImage={spaceImage}
                    />
                }
            </div>
            {uploading && <CircularWithValueLabel progress={progress} />}
            {langPop && createPortal(<PopLanguages fieldName={`Space Name`} languages={spaceNameLs} onSetLs={onSetSpaceNameLs} onLangPopClose={onSpaceNameLangPopClose} />, document.getElementById('modal'))}
            {narrationsPop && createPortal(<PopNarations narrations={narrations} onSetNarrations={onSetNarrations} onNarrationsPopClose={onNarrationsPopClose} />, document.getElementById('modal'))}
            {narrationsExtendedPop && createPortal(<PopNarations narrations={narrationsExtended} onSetNarrations={onSetNarrationsExtended} onNarrationsPopClose={onNarrationsExtendedPopClose} />, document.getElementById('modal'))}
        </>
    )
}

export default Space;